module.exports = __webpack_public_path__ + "static/media/My Way - Remix.843a2ba7.jpg";